import { hash } from '@ember/helper';
import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { tracked } from '@glimmer/tracking';

import type { DSSetup, PopupData, ValidationFunction } from 'webapp-types';

import CommonMetricAttributesUnitFieldsetComponent from 'webapp/components/common/metric-attributes-unit-fieldset';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class GoalsPopupCompareOtherMetricComponent extends PopupInnerModalComponent<PopupData.Goal.CompareOtherMetric> {
	@tracked targetOtherMetric: DSSetup.MetricSetupData | null;

	validateFieldset: null | ValidationFunction = null;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.targetOtherMetric = this.popupData.targetOtherMetric || null;
	}

	@action
	changeMetricSetupData(newValue: DSSetup.MetricSetupData): void {
		this.targetOtherMetric = newValue;
	}

	@action
	bindFieldsetValidation(validationFn: ValidationFunction) {
		this.validateFieldset = validationFn;
	}

	@action
	save(): void {
		if (this.validateFieldset && Object.keys(this.validateFieldset()).length !== 0) {
			return;
		}

		this.popupData.onChange(this.targetOtherMetric!);
		this.close();
	}
	<template>
		<div class="title">
			<CommonUiIconComponent @name="OkRs" @size="lg" />
			Select metric as target value
		</div>

		<div class="content">
			<CommonMetricAttributesUnitFieldsetComponent
				@model={{this.targetOtherMetric}}
				@formOptions={{hash legend="Select a metric to compare to" showErrorMessages=true}}
				@changeMetricSetupData={{this.changeMetricSetupData}}
				@validationBinder={{this.bindFieldsetValidation}}
				@requireSingleOutput={{true}}
				@onContentChange={{this.scheduleReposition}}
			/>

			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent
						@text="Cancel"
						@theme="grey-empty"
						@noDelay={{true}}
						@onTrigger={{this.close}}
					/>
					<SubmitButtonComponent
						@text="Save"
						@extraClass="save"
						@onTrigger={{this.save}}
					/>
				</div>
			</div>
		</div>
	</template>
}
